<template>
	<v-container class="fill-height">
		<v-row align="center" justify="center">
			<v-dialog
				v-model="show"
				:width="$vuetify.display.smAndDown ? '80%' : '40%'"
				max-width="1200"
				persistent
				style="z-index: 9999"
			>
				<BaseCard
					data-test="global-error"
					:title="error?.header"
					:top-divider="typeof error?.header !== 'undefined'"
					divider="both"
					title-class="error--text"
					:prepend-icon="error.icon"
				>
					<template #text>
						<div v-html="error.message"></div>
					</template>
					<template v-if="statusCode !== 403 || error3001" #actions>
						<ButtonIcon
							:color="error3001 ? 'success' : 'info'"
							:icon="error3001 ? 'fa-solid fa-check' : 'fal fa-sync'"
							:loading="reloading"
							:text="error3001 ? 'Bestätigen' : 'Aktualisieren'"
							@click.stop="loadTheme()"
						/>
						<ButtonIcon
							v-if="!error3001"
							color="error"
							icon="fal fa-times"
							text="Schließen"
							@click.stop="show = false"
						/>
					</template>
				</BaseCard>
			</v-dialog>
		</v-row>
	</v-container>
</template>

<script>
import BaseCard from '@/components/templates/Card/BaseCard'
import errorMessages from 'constants/errorMessages'
import { find } from 'lodash'
import {
	useAlertStore,
	useAuthStore,
	useThemeStore,
	useUserStore,
} from '@/stores/system'

export default {
	name: 'ShowError',
	components: {
		BaseCard,
	},
	props: {
		connection: {
			type: Boolean,
			default: false,
		},
		statusCode: {
			type: Number,
			default: 0,
			required: true,
		},
	},
	setup() {
		const alertStore = useAlertStore()
		const themeStore = useThemeStore()
		const userStore = useUserStore()
		const authStore = useAuthStore()

		return {
			alertStore,
			userStore,
			themeStore,
			authStore,
		}
	},
	data: () => ({
		errorMessages,
		reloading: false,
		show: true,
		errors: {
			api: {
				icon: 'fal fa-exclamation-circle',
				header: 'Verbindung nicht möglich',
				message:
					'Leider konnten wir im Moment keine Verbindung zu unserem Dienst herstellen. ' +
					'Der Dienst ist zurzeit leider nicht verfügbar.<br /><br /> Bitte versuchen Sie es später noch einmal.',
			},
			client: {
				icon: 'fal fa-user-slash',
				header: 'Kein gültiger Zugang',
				message:
					'Für die angegebene Adresse konnte leider kein gültiger Zugang ermittelt werden!<br /><br /> ' +
					'Bitte überprüfen Sie die Schreibweise der aufgerufenen Adresse oder wenden Sie sich an Ihren Verwalter.',
			},
			connection: {
				icon: 'fal fa-wifi-slash',
				header: 'Keine Internetverbindung',
				message:
					'Es besteht keine Internetverbindung. Bitte überprüfen Sie Ihre Einstellungen und ' +
					'versuchen es erneut',
			},
			default: {
				icon: 'fal fa-bug',
				header: 'Es ist ein Fehler aufgetreten',
				message:
					'Es ist ein Fehler aufgetreten.<br />Bitte entschuldigen Sie die Unannehmlichkeiten!',
			},
			maintenance: {
				icon: 'fal fa-user-hard-hat',
				header: 'Wartungsarbeiten',
				message:
					'Leider konnten wir im Moment keine Verbindung zu unserem Dienst herstellen. ' +
					'Es werden Wartungsarbeiten durchgeführt.<br /><br /> Bitte versuchen Sie es später noch einmal.',
			},
		},
	}),
	computed: {
		error() {
			if (!this.connection) {
				return this.errors.connection
			} else if (this.statusCode === 500 || this.statusCode === 502) {
				return this.errors.default
			} else if (this.statusCode === 403) {
				if (this.alertStore.failure.data.code === 3001) {
					return {
						...find(this.errorMessages, {
							error: this.alertStore.failure.error,
							code: this.alertStore.failure.data.code,
						}),
						...{ icon: 'fa-solid fa-file-signature' },
					}
				}
				return this.errors.client
			} else if (this.statusCode === 503) {
				return this.errors.maintenance
			}
			return this.errors.default
		},
		error3001() {
			return (
				this.statusCode === 403 && this.alertStore.failure.data.code === 3001
			)
		},
	},
	mounted() {
		if (this.error3001) {
			this.authStore.removeCookie()
		}
	},
	methods: {
		loadTheme() {
			location.reload()
			// this.reloading = true
			// this.themeStore
			// 	.load()
			// 	.then(() => location.reload())
			// 	.finally(() => {
			// 		this.reloading = false
			// 	})
		},
	},
}
</script>

<style scoped></style>
